import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { retrieveAllWorkQs } from "../lib/systemData"

export default function CheckWorkQSlug() {
    const params = useParams()
    const navigate = useNavigate()

    useEffect(() => {     
        if (params && params.workqSlug) {
            const allWorkQs = retrieveAllWorkQs() 
            if (allWorkQs && allWorkQs.length) {
                let currentWorkQ = allWorkQs.find(item => item.slug == params.workqSlug)

                if (!currentWorkQ) {
                    navigate(`/work-queues/${allWorkQs[0].slug}`, {replace: true});
                }
            }
            
        }
    }, [params])

    return null
}